import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "reducer/store";
import Home from "page/home";
import AccountPage from "page/account";
import VerifyMailPage from "page/verify-mail/change-mail";
import RegisterEmailPage from "page/verify-mail/register-email";
import ForgotPasswordPage from "page/forgot-password";
import ResetPasswordPage from "page/verify-mail/reset-password";
import LinkEmailPage from "page/verify-mail/link-email";
import RequestTokenPage from "page/request-token";
import ScrollToTop from "./scrollToTop";
import DetailFarmerPage from "page/detail-farmer";
import ui from "../../src/services/ui";
import { useEffect, useState } from "react";
import ReferralPage from "page/referral";
import { useTranslation } from "react-i18next";
import { CustomerInterface } from "interfaces";
import RafflePage from "page/raffle";
import MAGVault from "page/mag-vault";
import { ExchangePoint } from "page/mag-vault/exchange-point";
import GameLinkEmailPage from "page/verify-mail/game-link-email";

function RequireAuth({ children }: any) {
  const userInfo = useSelector((state: RootState) => state.user);
  const { t } = useTranslation();
  const [isLogin, setIsLogin] = useState(null);
  useEffect(() => {
    if (!userInfo?.[CustomerInterface.id]) {
      setIsLogin(false);
      ui.alertFailed(t("must_login_first"), "");
    }
  }, []);

  if (userInfo?.[CustomerInterface.id]) {
    return children;
  } else if (isLogin === false) {
    return <Navigate to="/" />;
  } else {
    return <></>;
  }
}

export default function Main() {
  return (
    <div>
      <div className={`w-full max-w-[100vw] overflow-hidden`}>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/account"
              element={
                <RequireAuth>
                  <AccountPage />
                </RequireAuth>
              }
            />
            <Route
              path="/account/:identity"
              element={
                <RequireAuth>
                  <DetailFarmerPage />
                </RequireAuth>
              }
            />
            <Route path="/verify-mail/:token" element={<VerifyMailPage />} />
            <Route path="/request-token" element={<RequestTokenPage />} />
            <Route path="/link-email/:token" element={<LinkEmailPage />} />
            <Route
              path="/register-email/:token"
              element={<RegisterEmailPage />}
            />
            <Route
              path="/link-game-email/:token"
              element={<GameLinkEmailPage />}
            />
            <Route
              path="/reset-password/:token"
              element={<ResetPasswordPage />}
            />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route
              path="/referral"
              element={
                <RequireAuth>
                  <ReferralPage />
                </RequireAuth>
              }
            />
            <Route
              path="/raffle"
              element={
                <RequireAuth>
                  <RafflePage />
                </RequireAuth>
              }
            />
            <Route
              path="/mag-vault"
              element={
                <RequireAuth>
                  <MAGVault />
                </RequireAuth>
              }
            />
            <Route
              path="/exchange-point/:rarity"
              element={
                <RequireAuth>
                  <ExchangePoint />
                </RequireAuth>
              }
            />
          </Routes>
        </ScrollToTop>
      </div>
    </div>
  );
}
